module.exports = __webpack_public_path__ + "static/media/agallery15.91c0db48.png";